import { gql } from "@apollo/client";

export const GET_OUTFITS_QUERY = gql`
  query GetOutfits {
    getCurrentUser {
      id
      firstName
      outfits {
        id
        imageUrl
        occasion
        favorited
        reasonings {
          id
          role
          message
          createdAt
        }
        outfitItems {
          id
          category {
            id
            name
          }
          item
          colors
          style
          imageUrl
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_CURRENT_USER_QUERY = gql`
  query {
    getCurrentUser {
      id
      name
      title
      dateFormat
      email
      avatar
      onboarded
      currentOrganisation {
        id
        name
      }
      role {
        id
        name
      }
      mfaEnabled
      mfaBackupCodeCount
    }
  }
`;

export const ORGANISATION_USERS_QUERY = gql`
  query OrganisationUsers {
    organisationUsers {
      totalCount
      nodes {
        id
        user {
          id
          name
          title
          email
          avatar
          status
          active
        }
        role {
          id
          name
        }
      }
    }
  }
`;

export const MY_ORGANISATIONS_QUERY = gql`
  query MyOrganisations {
    myOrganisations {
      totalCount
      nodes {
        teamSize
        id
        organisation {
          id
          name
        }
        role {
          id
          name
        }
        createdAt
      }
    }
  }
`;

export const ROLES_QUERY = gql`
  query Roles {
    roles {
      id
      name
      description
    }
  }
`;

export const AUDIT_LOGS_QUERY = gql`
  query GetLogs($limit: Int, $offset: Int) {
    getLogs(limit: $limit, offset: $offset) {
      id
      action
      auditableType
      auditableId
      userId
      organisationId
      username
      createdAt
      comment
      auditedChanges
      associatedId
      associatedType
    }
  }
`;
